//src/assets/scripts/top/page.js
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

import Swiper from 'swiper';
import 'swiper/css';
import "swiper/css/scrollbar";
import { Autoplay, Scrollbar, Mousewheel, Navigation, Thumbs } from "swiper/modules";

export default class PageJS {
    constructor(common) {
        this.common = common;
        this.BREAK_SP = 767;
    }

    mq(type = "sp") {
        if (type === "sp") return `(max-width: ${this.BREAK_SP}px)`;
        if (type === "pc") return `(min-width: ${this.BREAK_SP + 1}px)`;
        return type;
    }

    init() {
        this._secAbout();
        this._mapImgPc();
        this._navAreaCurrent();
        this._navSwiper();
        this._thumbnailSwiper();

        this.common.init();//common.jsはここでinitさせる
    }

    getAssetPath(relative) {
        const hostname = window.location.hostname;
        const isLocal =
            hostname === 'localhost' ||
            hostname === '127.0.0.1' ||
            hostname.endsWith('.local');
        if (isLocal) {
            return `/dist/assets/images/${relative}`;
        } else {
            return `/wp/wp-content/themes/theme-villamom/dist/assets/images/${relative}`;
        }
    }

    _secAbout_BK() {

        const about = document.querySelector("#About_area");
        if (!about) return;

        if (this._aboutMM) this._aboutMM.revert();
        this._aboutMM = gsap.matchMedia();

        this._aboutMM.add(this.mq("sp"), () => {

            const txt = about.querySelector(".txt_area");
            const txt_in = about.querySelector(".txt_area .in");

            const getMove = () => {
                return txt.scrollHeight - window.innerHeight;
            };

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: about,
                    start: "top top",
                    end: () => "+=" + getMove(),
                    scrub: true,
                    pin: true,
                    anticipatePin: 1,
                    invalidateOnRefresh: true
                }
            });

            tl.to(txt_in, {
                y: () => -getMove(),
                ease: "none"
            });

            return () => {
                tl.scrollTrigger.kill();
                tl.kill();
            };
        });
    }
    _secAbout() {
        const about = document.querySelector("#About_area");
        if (!about) return;

        if (this._aboutSpMM) this._aboutSpMM.revert();
        this._aboutSpMM = gsap.matchMedia();

        this._aboutSpMM.add(this.mq("sp"), () => {
            const txt = about.querySelector(".txt_area");
            const txt_in = about.querySelector(".txt_area .in");
            const imgArea = about.querySelector(".img_area");
            const btn = about.querySelector(".btn");
            if (!txt || !txt_in || !imgArea || !btn) return;

            const getMove = () => {
                return Math.max(0, txt.scrollHeight - window.innerHeight);
            };

            const showBtn = () => btn.classList.add("is-show");
            const hideBtn = () => btn.classList.remove("is-show");

            hideBtn();

            gsap.set(txt, {
                autoAlpha: 0,
                y: 40
            });

            gsap.set(imgArea, {
                "--about-overlay-opacity": 0
            });

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: about,
                    start: "top top",
                    end: () => "+=" + (getMove() + window.innerHeight * 0.8),
                    scrub: 1,
                    pin: true,
                    anticipatePin: 1,
                    invalidateOnRefresh: true,

                    onEnter: () => showBtn(),
                    onEnterBack: () => showBtn(),
                    onLeave: () => hideBtn(),
                    onLeaveBack: () => hideBtn(),

                    onUpdate: (self) => {
                        if (self.progress >= 0.95) {
                            hideBtn();
                        } else {
                            showBtn();
                        }
                    }
                }
            });

            tl.to(txt, {
                    autoAlpha: 1,
                    y: 0,
                    duration: 0.25,
                    ease: "power2.out"
                }, 0)
                .to(imgArea, {
                    "--about-overlay-opacity": 0.48,
                    duration: 0.1,
                    ease: "none"
                }, 0)
                .to(txt_in, {
                    y: () => -getMove(),
                    duration: 1,
                    ease: "none"
                }, 0);

            return () => {
                hideBtn();
                tl.scrollTrigger?.kill();
                tl.kill();
            };
        });
    }

    _mapImgPc_BK() {
        const area = document.querySelector('#Floor_map_area');
        if (!area) return;

        if (this._mapImgPcMM) this._mapImgPcMM.revert();
        this._mapImgPcMM = gsap.matchMedia();

        this._mapImgPcMM.add(this.mq("pc"), () => {

            const navItems = area.querySelectorAll('.nav_area li');
            const images = area.querySelectorAll('.map_img_area .img');

            if (!navItems.length || !images.length) return;

            const setCurrent = (index) => {
                images.forEach((img) => img.classList.remove('map_current'));
                images[index]?.classList.add('map_current');
            };

            // 👇ここ強化（確実に初期反映）
            requestAnimationFrame(() => {
                setCurrent(0);
            });

            navItems.forEach((li, index) => {
                const onEnter = () => setCurrent(index);
                li.addEventListener('mouseenter', onEnter);
                li._mapImgPcHandler = onEnter;
            });

            return () => {
                navItems.forEach((li) => {
                    if (li._mapImgPcHandler) {
                        li.removeEventListener('mouseenter', li._mapImgPcHandler);
                        li._mapImgPcHandler = null;
                    }
                });

                // 👇戻すときも初期状態に
                images.forEach((img, i) => {
                    img.classList.toggle('map_current', i === 0);
                });
            };
        });
    }
    _mapImgPc() {
        const area = document.querySelector('#Floor_map_area');
        if (!area) return;

        if (this._mapImgPcMM) this._mapImgPcMM.revert();
        this._mapImgPcMM = gsap.matchMedia();

        this._mapImgPcMM.add(this.mq("pc"), () => {
            const navItems = area.querySelectorAll('.nav_area li');
            const images = area.querySelectorAll('.map_img_area .img');
            const navArea = area.querySelector('.nav_area');

            if (!navItems.length || !images.length || !navArea) return;

            const clearCurrent = () => {
                images.forEach((img) => img.classList.remove('map_current'));
            };

            const showDefault = () => {
                clearCurrent();
                const defaultImg = area.querySelector('.map_img_area .img0');
                if (defaultImg) {
                    defaultImg.classList.add('map_current');
                }
            };

            const showByNumber = (num) => {
                clearCurrent();
                const target = area.querySelector(`.map_img_area .img${num}`);
                if (target) {
                    target.classList.add('map_current');
                }
            };

            // 初期表示
            requestAnimationFrame(() => {
                showDefault();
            });

            navItems.forEach((li) => {
                const link = li.querySelector('a[href^="#Floor_map"]');
                if (!link) return;

                const href = link.getAttribute('href');
                const match = href.match(/Floor_map(\d+)/);
                if (!match) return;

                const num = match[1];

                const onEnter = () => showByNumber(num);

                li.addEventListener('mouseenter', onEnter);
                li._mapImgPcHandler = onEnter;
            });

            const onLeaveNav = () => {
                showDefault();
            };

            navArea.addEventListener('mouseleave', onLeaveNav);
            navArea._mapImgPcLeaveHandler = onLeaveNav;

            return () => {
                navItems.forEach((li) => {
                    if (li._mapImgPcHandler) {
                        li.removeEventListener('mouseenter', li._mapImgPcHandler);
                        li._mapImgPcHandler = null;
                    }
                });

                if (navArea._mapImgPcLeaveHandler) {
                    navArea.removeEventListener('mouseleave', navArea._mapImgPcLeaveHandler);
                    navArea._mapImgPcLeaveHandler = null;
                }

                showDefault();
            };
        });
    }

    _navAreaCurrent() {
        const nav = document.querySelector("#Floor_map_area .nav_area");
        if (!nav) return;

        this._navAreaMM = this._navAreaMM || gsap.matchMedia();

        this._navAreaMM.add(this.mq("pc"), () => {
            const links = Array.from(nav.querySelectorAll('li a[href^="#"]')).filter((link) => {
                const href = link.getAttribute("href");
                return href && href !== "#" && document.querySelector(href);
            });

            const triggers = [];

            links.forEach((link) => {
                const href = link.getAttribute("href");
                const target = document.querySelector(href);
                const li = link.closest("li");

                if (!target || !li) return;

                triggers.push(
                    ScrollTrigger.create({
                        trigger: target,
                        start: "top center",
                        end: "bottom center",
                        toggleClass: {
                            targets: li,
                            className: "current"
                        }
                    })
                );
            });

            return () => {
                triggers.forEach((st) => st.kill());
                nav.querySelectorAll("li.current").forEach((li) => li.classList.remove("current"));
            };
        });
    }

    _navSwiper_BK() {
        const el = document.querySelector("#Floor_map_area .nav_swiper");
        if (!el) return;

        this._navSwiperMM = this._navSwiperMM || gsap.matchMedia();

        this._navSwiperMM.add(this.mq("sp"), () => {
            const scrollbarEl = document.querySelector(".nav_swiper-scrollbar");

            const swiper = new Swiper(el, {
                modules: [Scrollbar, Mousewheel],
                direction: "vertical", // 縦
                slidesPerView: "auto",
                freeMode: true,
                scrollbar: {
                    el: scrollbarEl,
                    draggable: true,
                },
                mousewheel: true,
            });

            return () => {
                swiper.destroy(true, true);
            };
        });
    }
    _navSwiper_BK2() {
        const area = document.querySelector("#Floor_map_area");
        if (!area) return;

        const el = area.querySelector(".nav_swiper");
        if (!el) return;

        this._navSwiperMM = this._navSwiperMM || gsap.matchMedia();

        this._navSwiperMM.add(this.mq("sp"), () => {
            const scrollbarEl = area.querySelector(".nav_swiper-scrollbar");
            const images = area.querySelectorAll(".map_img_area .img");

            if (!scrollbarEl || !images.length) return;

            const setMapCurrent = (index) => {
                images.forEach((img) => img.classList.remove("map_current"));
                images[index]?.classList.add("map_current");
            };

            const swiper = new Swiper(el, {
                modules: [Scrollbar, Mousewheel],
                direction: "vertical",
                slidesPerView: "auto",
                freeMode: true,
                watchSlidesProgress: true,
                centeredSlides: false,
                scrollbar: {
                    el: scrollbarEl,
                    draggable: true,
                },
                mousewheel: true,
                on: {
                    init: function () {
                        setMapCurrent(this.activeIndex || 0);
                    },
                    activeIndexChange: function () {
                        setMapCurrent(this.activeIndex || 0);
                    },
                    sliderMove: function () {
                        setMapCurrent(this.activeIndex || 0);
                    },
                    touchEnd: function () {
                        setMapCurrent(this.activeIndex || 0);
                    },
                    transitionEnd: function () {
                        setMapCurrent(this.activeIndex || 0);
                    }
                }
            });

            return () => {
                swiper.destroy(true, true);
                images.forEach((img) => img.classList.remove("map_current"));
            };
        });
    }
    _navSwiper() {
        const area = document.querySelector("#Floor_map_area");
        if (!area) return;

        const el = area.querySelector(".nav_swiper");
        if (!el) return;

        this._navSwiperMM = this._navSwiperMM || gsap.matchMedia();

        this._navSwiperMM.add(this.mq("sp"), () => {
            const scrollbarEl = area.querySelector(".nav_swiper-scrollbar");
            const navSlides = area.querySelectorAll(".nav_swiper .swiper-slide");
            const images = area.querySelectorAll(".map_img_area .img");

            if (!scrollbarEl || !navSlides.length || !images.length) return;

            const clearCurrent = () => {
                images.forEach((img) => img.classList.remove("map_current"));
            };

            const showByNumber = (num) => {
                clearCurrent();
                const target = area.querySelector(`.map_img_area .img${num}`);
                if (target) {
                    target.classList.add("map_current");
                }
            };

            const getNumberFromSlide = (index) => {
                const slide = navSlides[index];
                if (!slide) return 1;

                const link = slide.querySelector('a[href^="#Floor_map"]');
                if (!link) return 1;

                const href = link.getAttribute("href");
                const match = href.match(/Floor_map(\d+)/);
                if (!match) return 1;

                return match[1];
            };

            const setMapCurrent = (index) => {
                const num = getNumberFromSlide(index);
                showByNumber(num);
            };

            const swiper = new Swiper(el, {
                modules: [Scrollbar, Mousewheel],
                direction: "vertical",
                slidesPerView: "auto",
                freeMode: true,
                watchSlidesProgress: true,
                centeredSlides: false,
                scrollbar: {
                    el: scrollbarEl,
                    draggable: true,
                },
                mousewheel: true,
                on: {
                    init: function () {
                        showByNumber(1);
                    },
                    activeIndexChange: function () {
                        setMapCurrent(this.activeIndex || 0);
                    },
                    sliderMove: function () {
                        setMapCurrent(this.activeIndex || 0);
                    },
                    touchEnd: function () {
                        setMapCurrent(this.activeIndex || 0);
                    },
                    transitionEnd: function () {
                        setMapCurrent(this.activeIndex || 0);
                    }
                }
            });

            return () => {
                swiper.destroy(true, true);
                clearCurrent();
                showByNumber(1);
            };
        });
    }

   
    _thumbnailSwiper() {
        const areas = document.querySelectorAll(".thumbnail_swiper_area");
        if (!areas.length) return;

        areas.forEach((area) => {
            const mainEl = area.querySelector(".type_swiper");
            const thumbEl = area.querySelector(".type_thumbnail");

            if (!mainEl || !thumbEl) return;

            // すでに初期化済みならスキップ
            if (mainEl.swiper || thumbEl.swiper) return;

            const thumbSwiper = new Swiper(thumbEl, {
                slidesPerView: "auto",
                watchSlidesProgress: true,
            });

            new Swiper(mainEl, {
                modules: [Thumbs],
                slidesPerView: "auto",
                spaceBetween: 0,
                speed: 600,
                thumbs: {
                    swiper: thumbSwiper,
                },
            });
        });
    }









}